import { Button } from '@eg/elements/Button';
import { Modal } from '@eg/elements/components/Modal';
import { FC } from 'react';
import Text from '../Text';
import './CancelSignModal.css';

export interface CancelSignModalProps {
  open: boolean;
  onCloseModal: () => void;
  onGoBack: () => void;
  onDismissModal: () => void;
}

export const CancelSignModal: FC<CancelSignModalProps> = ({
  open,
  onCloseModal,
  onGoBack,
  onDismissModal,
}) => (
  <Modal open={open} dismissLabel={'schließen'} dismissible={true} onDismiss={onDismissModal}>
    <p>
      <Text>
        <b>Bitte beachten Sie:</b>
      </Text>
      <Text>
        Wenn Sie <b>zurückgehen</b>, verlieren Sie Ihre Unterschriften und müssen erneut
        unterschreiben.
      </Text>
      <Text>
        Wenn Sie auf der aktuellen Seite bleiben, behalten Sie Ihre Unterschriften. Sie können dann
        den Online-Antrag direkt absenden.
      </Text>
    </p>
    <br />

    <div className="modal-buttons">
      <Button type="button" variant="primary" size="large" onClick={onCloseModal}>
        Online-Abschluss fortsetzen
      </Button>
      <Button size="large" onClick={onGoBack}>
        zurück & neu unterschreiben
      </Button>
    </div>
  </Modal>
);
